<template>
	<div id="indexpage" v-title :data-title="title" style="height:100%;">
		<!-- <headerbar msg="chanyednao" :curindex="false"> </headerbar> --> 
			<!-- <el-drawer  title="我是标题"  :visible.sync="drawer2"  :with-header="false"  	:direction='direction' 	size='240px' 	:modal-append-to-body="modal"> -->
		<leftnav  mkcode="D" itemcode="D-ZSHJ"  :smScrennFull="true"></leftnav>
			<!-- </el-drawer> -->
			<!-- <span class="screen" @click="drawer2 = true"  ><i class="el-icon-s-unfold"></i>菜单栏</span> -->
		<!-- 弹框 -->	 
		<div class="por" style="background-color: #041034;height:100%;">
			<div class="index-swiper centerpage">
				<daswiperNav :title="title" :indexnum="7"  navcode="ZSTP" :fulltitle="true"></daswiperNav>
				<div class="indexflex">
					 <div class="col3  zstp_left">
							 <div class="transparentbg" :class="lowerlist.list.length==0?'zstp_left_h':'zstp_left_up'" v-if="Upperlist.list.length>0">
									<h3 class="swiper_title">上游重点招商企业</h3>
									<div class="orgfont zstp_left_uporgfont">
										<ul class="flexcss">
											<li v-for="item in Upperlist.notion">{{item.name}}（{{item.count}}家）</li>
											<!-- <li>负极材料（20家）</li>
											<li>负极材料（20家）</li> -->
										</ul>
									</div>
									<div class="zstp_left_tabbox">
									<div class="thbox">
										<ul class="flexcss"> 
											<li class="th_list1">企业名称</li>
											<li class="th_list2">省</li>
											<li class="th_list2">市</li> 
											<li class="th_list4">行业</li> 
											<li class="th_list3">联系方式</li>
											</ul> 
											</div>
											<div :class="lowerlist.list.length==0?'zstp_scrollbox-h':'zstp_scrollbox'" >
											<vue-seamless-scroll :data="Upperlist.list"  :class-option="defaultOption" > <!-- :data="pagedata.up"  :class-option="defaultOption" -->
											<ul class="zstp_tab flexcss " v-for="item in Upperlist.list">
												<li class="th_list1" @click="routerlinkid('/enterprises',item.stockCode)">{{item.title}}</li>		
												<li class="th_list2">{{item.province}}</li>
												<li class="th_list2">{{item.city}}</li> 
												<li class="th_list4">{{item.industry}}</li> 
												<li class="th_list3">{{item.phone}}</li>
												</ul> 
										</vue-seamless-scroll >
									</div>
										</div>
								</div>
								<div class=" transparentbg" :class="lowerlist.list.length==0?'zstp_left_h':'zstp_left_middle'" :style="Upperlist.list.length>0?'':h">
									<h3 class="swiper_title">中游重点招商企业</h3>
									<div class="orgfont zstp_left_uporgfont">
										<ul class="flexcss">
											<li v-for="item in middlelist.notion">{{item.name}}（{{item.count}}家）</li>
										</ul>
									</div>
									<div class="zstp_left_tabbox">
									<div class="thbox">
										<ul class="flexcss"> 
											<li class="th_list1">企业名称</li>
											<li class="th_list2">省</li>
											<li class="th_list2">市</li> 
											<li class="th_list4">行业</li> 
											<li class="th_list3">联系方式</li>
											</ul> 
											</div>
											<div :class="lowerlist.list.length==0?'zstp_scrollbox-h':'zstp_scrollbox'" :style="Upperlist.list.length>0?'':hs">
											<vue-seamless-scroll :data="middlelist.list"  :class-option="defaultOption" >   <!-- :data="colors"  :class-option="defaultOption" -->
												<ul class="zstp_tab flexcss " v-for="item in middlelist.list">
													<li class="th_list1" @click="routerlinkid('/enterprises',item.stockCode)">{{item.title}}</li>		
													<li class="th_list2">{{item.province}}</li>
													<li class="th_list2">{{item.city}}</li> 
													<li class="th_list4">{{item.industry}}</li> 
													<li class="th_list3">{{item.phone}}</li>
													</ul> 	
												 
										</vue-seamless-scroll >
									</div>
										</div>
								</div>
								<div class="zstp_left_lower transparentbg" v-show="lowerlist.list.length>0">
									<h3 class="swiper_title">下游重点招商企业</h3>
									<div class="orgfont zstp_left_uporgfont">
										<ul class="flexcss">
											<li v-for="item in lowerlist.notion">{{item.name}}（{{item.count}}家）</li>
										</ul>
									</div>
									<div class="zstp_left_tabbox">
									<div class="thbox">
										<ul class="flexcss"> 
											<li class="th_list1">企业名称</li>
											<li class="th_list2">省</li>
											<li class="th_list2">市</li> 
											<li class="th_list4">行业</li> 
											<li class="th_list3">联系方式</li>
											</ul> 
											</div>
											<div class="zstp_scrollbox">
											<vue-seamless-scroll :data="lowerlist.list"  :class-option="defaultOption" >   <!-- :data="colors"  :class-option="defaultOption" -->
												<ul class="zstp_tab flexcss " v-for="item in lowerlist.list">
													<li class="th_list1" @click="routerlinkid('/enterprises',item.stockCode)">{{item.title}}</li>		
													<li class="th_list2">{{item.province}}</li>
													<li class="th_list2">{{item.city}}</li> 
													<li class="th_list4">{{item.industry}}</li> 
													<li class="th_list3">{{item.phone}}</li>
													</ul> 	
										</vue-seamless-scroll >
									</div>
										</div>
								</div>
						</div>
						<div class="col4  zstp_center">
							<div class="zstp_center_cylnavbox">
								<ul class="">
								<li class="" @click="clynav=i;chainid = item.chainId;getajasdata()"  :class="clynav==i?'navbg':''" v-for="(item,i) in pagedata.chainList">{{item.chainName}}</li>
								<!-- <li class="" @click="clynav=2;getajasdata(35)"  :class="clynav==2?'navbg':''">医疗器械</li> 
								<li class="" @click="clynav=3;getajasdata(108)"  :class="clynav==3?'navbg':''">人工智能</li> -->
							</ul>
							<!-- {{graphData}} -->
							</div>
						 <!-- <ul class="flexcss zstp_top transparentbg">
						 	<li v-for="item in pagedata.currentChain.enterpriseCount">
						 		<h5 class="title">{{item.name}}</h5>
						 		<p><strong class="numf"><countTo :endVal='item.value' :startVal='0' :props="contodefault">100</countTo></strong><span>家</span></p>
						 	</li> 
						 </ul> -->
							 <div class="zstp_center_bottom">
								<!-- <chain ref="chain" :graphData="pagedata.currentChain.graphData" style="height: 500px;"></chain> -->
								<!-- <img src="../../assets/img/cyl1.png" /> -->
								<iframe :src="iframeurl" scrolling="yes" frameborder="none" style="width: 100%;height: 100%;" ></iframe>
								<div class="iframeMask"  @click="chainrouter1(chainid)"></div>
								</div>
						</div>
						<div class="col3  zstp_right">
							 <div class="zstp_right_node transparentbg">
							 	<h3 class="swiper_title">招商企业区域分布</h3>
									<div id="zstp_regional"></div>
									<!-- <table border="0" cellspacing="0" cellpadding="0" 	class="">
										<tr >  
											<th rowspan="2">重点节点</th>
											<th colspan="2">市场规模（亿元）</th> 
											<th colspan="3"> 招商机会分析</th>
											<th colspan="3" style="display:none"> 投资机会分析</th>
										</tr>
										<tr class="fwn">
											<th>2019年</th>
											<th>2025年</th> 
											<th class="cyfz_areas">适合区域</th>
											<th style="display:none">选址区域</th>
											<th>招商时机</th>
											<th style="display:none">进入时机</th>
											<th>推荐程度</th>
										</tr> 
										<tr class="tboy" v-for="(item,i) in pagedata.currentChain.chanceList" v-if="i<8">
											<td class="zstp_nodename">{{item.nodeName}}</td>
											<td>{{item.market}}</td>
											<td>{{item.marketForecast}}</td> 
											<td class="cyfz_areas">{{item.suitableArea}}</td>
											<td style="display:none">选址区域</td>
											<td>
												<el-rate  v-model="item.investChance"
													disabled
													show-score
													text-color="#0262de"
													:max="4"
													:colors="strcolors"
													score-template="">
													</el-rate>
														</td>
											<td style="display:none">进入时机</td>
											<td> 
											<el-rate  v-model="item.recommendLevel"
													disabled
													show-score
													text-color="#0262de"
													:max="4"
													:colors="strcolors"
													score-template="">
													</el-rate>
													</td>
										</tr>  
									</table> --> 
							 </div>
								<div class="zstp_right_contrast transparentbg">
									<h3 class="swiper_title">各行业招商企业数量对比</h3>
									<div id="zstp_right_chart"></div>
								</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'zhaoshangtupu',
		data() {
			return { 
					isCollapse:false,
					isFullscreen: false,
					direction:"ltr",  //btt
					direction2:"btt",  //btt
					 drawer: false,
						drawer2: false,
						modal:false,	
				title: "招商图谱数字大屏",
				bgcolor: "#041034",
				startVal: 0, //数字滚动开始值
				endVal1: 1425.44, //数字滚动结束 
				usernotionlistsave: [], 
				h:{height:'100%'}, 
				hs:{height:"665px"},
				userdata: {}, 
				clynav:0, //产业链切换
				mapurl: 'map/city/321200.json',
				contodefault: {
					duration: 1000,
					autoplay: true,
				},
				islogin: false,
				flag: true,
				swipernum: 3,
				zoom: 13,
				public_tooltip: {
					trigger: 'axis',
					backgroundColor: 'rgba(255,255,255,0.9)',
					borderColor: '#ddd',
					borderWidth: '1',
					textStyle: {
						color: '#000',
						fontSize: 14,
					}
				},
				iframeurl:'',
				chainid:0,
				mapurl: 'map/city/321200.json',
				colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
				landType: [],
				startCharts: null,
				graphData:'23213',
				pagedata:{currentChain:{industryList:[],enterpriseCount:[],enterpriseCount:[]},chainList:[{chainId:''}] },
				strcolors:['rgba(26, 147, 251, 0.9)', 'rgba(26, 147, 251, 0.9)', 'rgba(26, 147, 251, 0.9)'],
				//假数据 
				chartdata:[
					{name:"化学药",value:121},
					{name:"生物药",value:102},
					{name:"中药",value:51},
					{name:"诊断类设备",value:21},
					{name:"分子诊断",value:37},
					{name:"生化诊断",value:25},
					{name:"手术室耗材类",value:30},
					{name:"治疗设备类",value:20}, 
					],
				Upperlist:{notion:[],list:[]}, 
				middlelist:{notion:[],list:[]},
				lowerlist:{notion:[],list:[]},
				yyzzuplist:{	//医药制造上游企业
					list1:[{name:"化学原料药",value:344}],
					data:[
						{name:"浙江华海药业股份有限公司",province:"浙江省",city:'台州市',	industry:"医药制造业",Telephone:'0576-85010288'},
						{name:"浙江海正药业股份有限公司",province:"浙江省",city:'台州市',	industry:"医药制造业",Telephone:'0576-88827890'},
						{name:"健康元药业集团股份有限公司",province:"广东省",city:'深圳市',	industry:"医药制造业",Telephone:'0755-33268688'},
						{name:"山东新华制药股份有限公司",province:"山东省",city:'淄博市',	industry:"医药制造业",Telephone:'0533-2196303'},
						{name:"普洛药业股份有限公司",province:"浙江省",city:'金华市',	industry:"医药制造业",Telephone:'0579-86557820'}, 
					]
				},
				yyzzmiddlelist:{	//医药制造中游企业
					list1:[
						{name:"化学药",value:25},
						{name:"生物药",value:25},
							], 
					data:[
						{name:"江苏恒瑞医药股份有限公司",province:"江苏省",city:'连云港市',	industry:"医药制造业",Telephone:'0518-81220000'},
						{name:"华东医药股份有限公司",province:"浙江省",city:'杭州市',	industry:"医药制造业",Telephone:'0571-89903300'},
						{name:"上海医药集团股份有限公司",province:"上海市",city:'浦东新区',	industry:"医药制造业",Telephone:'021-63730908'},
						{name:"通化东宝药业股份有限公司",province:"吉林省",city:'通化市',	industry:"医药制造业",Telephone:'0435-5088008'},
						{name:"深圳信立泰药业股份有限公司",province:"广东省",city:'深圳市',	industry:"医药制造业",Telephone:'0755-83867888'}, 
					]
				},
				yyzzlowerelist:{	//医药制造下游企业
					list1:[ ],
					data:[
					{name:"江苏新时代造船有限公司 ",province:" 江苏省",city:'泰州市',	industry:"医药制造业",Telephone:'0571-88075998'},
					{name:"唐泽交通器材（泰州）有限公司",province:"江苏省",city:'泰州市',	industry:"医药制造业",Telephone:'021-61822810'},
					{name:"江苏扬电科技股份有限公司",province:"江苏省",city:'泰州市',	industry:"医药制造业",Telephone:'010-64318888'},
					{name:"泰州市泰信电机有限公司",province:"江苏省",city:'泰州市',	industry:"医药制造业",Telephone:'27-81338818'},
					{name:"江苏大中电机股份有限公司",province:"江苏省",city:'泰州市',	industry:"医药制造业",Telephone:'0536-3051234'}, 
					{name:"林海股份有限公司",province:"江苏省",city:'泰州市',	industry:"医药制造业",Telephone:'0755-66858889'},
					]
				},
				xlyuplist:{	//新能源汽车上游重点企业
					list1:[
						{name:"动力电池",value:493},
					{name:"驱动电机",value:197},
					{name:"电控系统",value:328},
					],
					data:[
						{name:"欣旺达电子股份有限公司",province:"广东省",city:'深圳市',	industry:"电气机械及器材制造业",Telephone:'0755-29516888'},
						{name:"惠州亿纬锂能股份有限公司",province:"广东省",city:'惠州市',	industry:"电气机械及器材制造业",Telephone:'0752-5751928'},
						{name:"孚能科技（赣州）股份有限公司",province:"江西省",city:'赣州市',	industry:"批发业",Telephone:'0510-7326600'},
						{name:"中山大洋电机股份有限公司",province:"广东省",city:'中山市',	industry:"通讯设备、计算机及其他电子设备",Telephone:'0760-88555123'},
						{name:"骆驼集团股份有限公司",province:"湖北省",city:'襄阳市',	industry:"批发业",Telephone:'0710-3340127'}, 
					]
				},
				xlymiddlelist:{	//新能源汽车中游重点企业
					list1:[
						{name:"新能源整车制造",value:367}, 
					],
					data:[
						{name:"比亚迪股份有限公司",province:"广东省",city:'深圳市',	industry:"电气机械及器材制造业",Telephone:'0755-89888888'},
						{name:"长城汽车股份有限公司",province:"河北省",city:'保定市',	industry:"汽车制造业",Telephone:'0752-5751928'},
						{name:"重庆长安汽车股份有限公司 ",province:"重庆市",city:'江北区',	industry:"汽车制造业",Telephone:'023-67594008'},
						{name:"奇瑞汽车股份有限公司",province:"安徽省",city:'芜湖市',	industry:"汽车制造业",Telephone:'0553-7533303'},
						{name:"广州小鹏汽车科技有限公司",province:"广东省",city:'广州市',	industry:"研究与试验发展",Telephone:'020-66806680'}, 
					]
				},
				xlylowerlist:{	//新能源汽下游重点企业
					list1:[
						{name:"充电桩",value:1329}, 
						{name:"动力电池回收",value:37},
					],
					data:[
						{name:"科大智能科技股份有限公司",province:"上海市",city:'浦东新区',	industry:"通讯设备、计算机及其他电子设备",Telephone:'021-50809880'},
						{name:"苏州工业园区和顺电气股份有限公司",province:"江苏省",city:'苏州市',	industry:"通讯设备、计算机及其他电子设备",Telephone:'0512-62862622'},
						{name:"英飞特电子（杭州）股份有限公司 ",province:"浙江省",city:'杭州市',	industry:"电气机械及器材制造业",Telephone:'0571-56565800'},
						{name:"深圳市恒创睿能环保科技有限公司",province:"广东省",city:'深圳市',	industry:"研究与试验发展",Telephone:'13502577424'},
						{name:"湖南金源新材料股份有限公司",province:"湖南省",city:'益阳市',	industry:"非金属矿物制品业",Telephone:'0737-7828968'}, 
					]
				},
				ylqxuplist:{	//新能源汽上游重点企业
					list1:[
						{name:"生物医用材料",value:142},
					],
					data:[
						{name:"大博医疗科技股份有限公司",province:"福建省",city:'厦门市',	industry:"专用设备制造业",Telephone:'0592-6087672'},
						{name:"山东国瓷功能材料股份有限公司",province:"山东省",city:'东营市',	industry:"化学原料及化学制品制造业",Telephone:'0546-8073788'},
						{name:"蓝帆医疗股份有限公司",province:"山东省",city:'淄博市',	industry:"橡胶制品业",Telephone:'0533-7871015'},
						{name:"英科医疗科技股份有限公司",province:"山东省",city:'淄博市',	industry:"橡胶制品业",Telephone:'0533-6298788'},
						{name:"烟台正海生物科技股份有限公司",province:"山东省",city:'烟台市',	industry:"医药制造业",Telephone:'0535-6931901'}, 
					]
				},
				ylqxmiddlelist:{	//新能源汽中游重点企业
					list1:[
						{name:"医用医疗设备",value:25},
						{name:"家用医疗器械",value:75}, 
					],
					data:[
						{name:"天津九安医疗电子股份有限公司",province:"天津市",city:'南开区',	industry:"专用设备制造业",Telephone:'022-87611660'},
						{name:"惠州市锦好医疗科技股份有限公司",province:"广东省",city:'惠州市',	industry:"通讯设备、计算机及其他电子设备",Telephone:'0752-2266961'},
						{name:"迈得医疗工业设备股份有限公司",province:"浙江省",city:'台州市',	industry:"仪器仪表业",Telephone:'0576-87498999'},
						{name:"爱威科技股份有限公司",province:"湖南省",city:'长沙市',	industry:"专用设备制造业",Telephone:'0731-89715453'},
						{name:"无锡祥生医疗科技股份有限公司",province:"江苏省",city:'无锡市',	industry:"专用设备制造业",Telephone:'0510-85310669'}, 
					]
				},
				ylqxlowerlist:{	//新能源汽中游重点企业
					list1:[],
					data:[
						{name:"杭州海康威视数字技术股份有限公司 ",province:" 浙江省",city:'杭州市',	industry:"制造业",Telephone:'0571-88075998'},
						{name:"上海韦尔半导体股份有限公司",province:"上海市",city:'上海市',	industry:"制造业",Telephone:'021-61822810'},
						{name:"京东方科技集团股份有限公司",province:"北京市",city:'北京市',	industry:"制造业",Telephone:'010-64318888'},
						{name:"武汉锐科光纤激光技术股份有限公司",province:"湖北省",city:'武汉市',	industry:"制造业",Telephone:'27-81338818'},
						{name:"歌尔股份有限公司",province:"山东省",city:'潍坊市',	industry:"制造业",Telephone:'0536-3051234'}, 
						{name:"欧菲光集团股份有限公司",province:"广东省",city:'深圳市',	industry:"制造业",Telephone:'0755-66858889'},
					]
				},
			}
		},
		watch: {//深度 watcher 
		  'clynav': {
		    handler (val, oldVal) {  
							this.iframeurl = this.$api.cyl.govsaaschart.chainurl()+"?id="+this.chainid+"&width=680";
		       console.log(val); 
		    },
		    // deep: true
		  }, 
		}, 
		props: {
			msg: String,
		},
		computed: {
			defaultOption() {
				return {
					step: 0.7, // 数值越大速度滚动越快
					limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 1, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
				}
			}
		},
		created() {
		 var _this=this;
			this.userdata = this.getuseriformation();
				document.getElementById('app').style.background = this.bgcolor;
		
			// this.iframeurl = this.$api.cyl.govsaaschart.chainurl()+"?id="+this.chainid+"&width=780";
		},
		
		mounted() { 
			this.bus.$emit('loading', true);
			if(this.userdata.edition<1){
					var _this=this;
				alert('升级版本后即可查看本页面,自动跳转');
					setTimeout(function(){
						_this.routerself('/totalEnterprises');
					},1000)
					return;
				}
		this.getajasdata(0); 
		// console.log(this.userdata);
		this.chainid = this.pagedata.chainList[0].chainId;
		},
		methods: {
			 
			getajasdata(type) {
				var _this = this; 
				this.bus.$emit('loading', true);
				if(type==0){
					var ajaxurl =this.$api.cyl.govsaaschart.busiInvestAtals();
				}else{
					var ajaxurl =this.$api.cyl.govsaaschart.busiInvestAtals()+'?chainId='+_this.chainid;
					// var ajaxurl =this.$api.cyl.govsaaschart.busiInvestAtals()+'?chainId=4'; //本地测试用的id
				}
				
				console.log(this.title);
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log(res); 
					_this.bus.$emit('loading', false);
					console.log('ajaxurl',ajaxurl);
					_this.pagedata = res.data.data||[];
					_this.Upperlist = _this.turndata(res.data.data.up);
					// _this.middlelist = _this.turndata(res.data.data.mid);
					// _this.lowerlist = _this.turndata(res.data.data.down);
					_this.middlelist = _this.turndata(res.data.data.mid);
					_this.lowerlist = _this.turndata(res.data.data.down);
					if(type ==0){
						_this.chainid =_this.pagedata.chainList[0].chainId;
						console.log('111',_this.pagedata)
						_this.iframeurl = _this.$api.cyl.govsaaschart.chainurl()+"?id="+_this.pagedata.chainList[0].chainId+"&width=680";
					}
					_this.chartfun('zstp_right_chart',res.data.data.currentChain.industryList);
					_this.entrendschartFun('zstp_regional',res.data.data.currentChain.areaList);
					_this.bus.$emit('loading', false);
					 
				}).catch(function(error) {
					_this.bus.$emit('loading', false);
					// 请求失败处理 console.log(error);
				});
			},  
			turndata(data){
				console.log('进入',data);
				var notion = [],list=[],nlist=[],ndata;
				for(var i=0;i<data.length;i++){ 
					// console.log('11',data[i].list);
					list = data[i].list;
					console.log(data[i].notion);
					notion.push({name:data[i].notion.text,count:data[i].notion.count});
					for(var j=0;j<list.length;j++){
						// console.log('11',list[j]);
						nlist.push(list[j])
					} 
				}
				ndata = {notion:notion,list:nlist};
				return ndata;
				// console.log('nontion:',notion,'nlist',nlist,'上游',ndata);
			},
			//产业链跳转详情页
			chainrouter1(chainid){
				let routeUrl = this.$router.resolve({
						path: '/chain',query:{id:chainid}
				});
				window.open(routeUrl.href, '_blank');  
			},
		 chartfun(el,data){
				var charPie3currentIndex = 0,isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
				var chart = echarts.init(document.getElementById(el)); 
				var _this = this,xline=[],seriesline=[];
				for(var i=0;i<data.length;i++){
					xline.push(data[i].name);
					seriesline.push(data[i].value);
				};
				var option = {
					tooltip:{
						show:true,
						trigger: 'axis',
						// backgroundColor: 'rgba(255,255,255,0.9)',
						// borderColor: '#ddd',
						// borderWidth: '1',
						// textStyle: {
						// 	color: '#000',
						// 	fontSize: 14,
						// }
						},
						grid: { x: 30, 	y: 30, x2: 20, y2: 80, show: true, 	borderWidth: 0,},
				  xAxis: {
				    type: 'category',
								axisLabel:{interval:0,rotate:40,fontSize: 12,color:'#fff'},
				    data: xline,
				  },
				  yAxis: {
				    type: 'value',
								splitLine:{show:false},
								axisTick:{show:false},
								axisLine: {show:false},
								axisLabel :{show:false}
				  },
				  series: [
				    {
				      data: seriesline,
				      type: 'bar',
										itemStyle: { normal: { color: '#5b8ff9', } }, 
										barWidth:18,
										label:{
										  normal:{ 
										  show: true, 
										  position: 'top',  //显示顶部数据
												color : '#fff',
												formatter: '{@score}'+'家'
										   }
										},
				    }
				  ]
				};  
				chart.setOption(option);
			},
			//企业行业分布
			entrendschartFun(el,data){
				var charPie3currentIndex = 0,isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
				var regionalchart = echarts.init(document.getElementById(el)); 
				var _this = this;  
				var option = {
					// color:this.colors,
				  title: {
				    text: ' ', 
				  },
				  tooltip: {
				    trigger: 'item',
								confine: true, //提示框被遮挡  是否将 tooltip 框限制在图表的区域内
				  },
				  // legend: {top: 'center',right:'15%',textStyle:{color:"#eee",fontSize:12,lineHeight:100},orient:'vertical',itemWidth:6,itemHeight:6, icon:'circle'	//图例圆形
				  // },
				  series: [
				    {
				      name: '',
				      type: 'pie',
				      radius: '50%',
										center: ["50%", "50%"],
				      data: data,
										// data:  [
										// 		{name: "高港区", 	value: 1432}, 
										// 		{name: "泰兴市", value: 1253}, 
										// 		{	name: "海陵区",value: 1104},
										// 		{name: "靖江市",value: 991},
										// 		{name: "兴化市",value: 593},
										// 		{name: "姜堰市",	value: 460},
										// ], 
											label: { show:true,  color: '#eee',  fontSize: 12	,   position: 'outside',  formatter: '{b} \n {d}%', },
				      emphasis: {
				        itemStyle: {
				          shadowBlur: 10,
				          shadowOffsetX: 0,
				          shadowColor: 'rgba(0, 0, 0, 0.5)'
				        }
				      }
				    }
				  ]
				};
				regionalchart.setOption(option);   
				var startCharts = null;
				// // 2、鼠标移动上去的时候的高亮动画
				// hgsj.on('mouseover', function(param) {
				// 	isSet = false
				// 	clearInterval(startCharts)
				// 	// 取消之前高亮的图形
				// 	hgsj.dispatchAction({
				// 		type: 'downplay',
				// 		seriesIndex: 0,
				// 		dataIndex: charPie3currentIndex
				// 	})
				// 	// 高亮当前图形
				// 	hgsj.dispatchAction({
				// 		type: 'highlight',
				// 		seriesIndex: 0,
				// 		dataIndex: param.dataIndex
				// 	})
				// 	// 显示 tooltip
				// 	hgsj.dispatchAction({
				// 		type: 'showTip',
				// 		seriesIndex: 0,
				// 		dataIndex: param.dataIndex
				// 	})
				// });
				// var chartHover = function() {
				// 	var dataLen = option.series[0].data.length
				// 	// 取消之前高亮的图形
				// 	hgsj.dispatchAction({
				// 		type: 'downplay',
				// 		seriesIndex: 0,
				// 		dataIndex: charPie3currentIndex
				// 	})
				// 	charPie3currentIndex = (charPie3currentIndex + 1) % dataLen
				// 	// 高亮当前图形
				// 	hgsj.dispatchAction({
				// 		type: 'highlight',
				// 		seriesIndex: 0,
				// 		dataIndex: charPie3currentIndex
				// 	})
				// 	// 显示 tooltip
				// 	hgsj.dispatchAction({
				// 		type: 'showTip',
				// 		seriesIndex: 0,
				// 		dataIndex: charPie3currentIndex
				// 	})
				// }
				// startCharts = setInterval(chartHover, 2000)
				// // 4、鼠标移出之后，恢复自动高亮
				// hgsj.on('mouseout', function(param) {
				// 	if (!isSet) {
				// 		startCharts = setInterval(chartHover, 2000)
				// 		isSet = true
				// 	}
				// });
			},
			
 		}
	}
</script>

<style scoped="scoped">
 #app{
 		background-color: #041034;
 	}
</style>
